export const debounce = (delay: number, fn: (...args: unknown[]) => void) => {
    let tid: ReturnType<typeof setTimeout> | null = null;
    return function(this: unknown, ...args: unknown[]) {
        if (tid) { clearTimeout(tid); }
        tid = setTimeout(() => fn.apply(this, args), delay);
    };
};